// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder--MCuV5","thumbnailPlaceholder":"thumbnailPlaceholder--MCuV5","emptyPlaceholder":"emptyPlaceholder--MCuV5"};